// Supplier reply 2026-09-24. Assign explicitly to the tested firmware's inventory;
// model name / GT06 alone cannot establish firmware capabilities.
export const YG_T11_CONTROL_PROFILE = 'yg-t11-20260924';
// Original T11.T12.xlsx and supplier follow-up 2026-10-09. Assignment is
// explicit and model-bound; receipts still require separate physical checks.
export const YOGU_SUPPLIER_CONTROLS={
 'yogu-t11-controls-20261009':{model:'T11'},
 'yogu-t12-controls-20261009':{model:'T12'},
};
export const YOGU_PRO_READBACK_TRIAL='yogu-d3-pro-readback-trial-20261009';
export const YOGU_PRO_36_PROFILE='yogu-d3-pro-controls-20261013';
// T94_SMS_Commands.xls, supplier update 2026-10-13. Commissioning reads
// establish each unit's firmware before enabling any writes.
export const YOGU_DRIVE_READBACK={
 'yogu-t94-readback-20261013':'T94',
 'yogu-t94-pro-readback-20261013':'T94 Pro',
};
// T94_SMS_Commands.xls R19 documents these two complete pairs, not a range.
// Writes require explicit commissioning and the separately observed firmware.
export const YOGU_DRIVE_CONTROLS={
 'yogu-t94-controls-20261013':'T94',
 'yogu-t94-pro-controls-20261013':'T94 Pro',
};
export const YOGU_DRIVE_TIMER_PAIRS=Object.freeze([Object.freeze([5,0]),Object.freeze([30,0])]);
// T94_SMS_Commands.xls R22/R24/R26/R27. These are reads only; alarm delivery
// and automatic arming must never be changed by an information request.
const DRIVE_ALARM_QUERIES=Object.freeze({vibrationAlarm:'SENALM#',autoArming:'DEFENSE#',batteryAlarm:'BATALM#',speedAlarm:'SPEED#'});
export function yoguDriveControlModel(key){
 return Object.hasOwn(YOGU_DRIVE_READBACK,key)?YOGU_DRIVE_READBACK[key]:Object.hasOwn(YOGU_DRIVE_CONTROLS,key)?YOGU_DRIVE_CONTROLS[key]:null;
}
// Written and independently read back on GT76E_V3.4 on 2026-10-12.
// The old profile retains its measured pairs. A separate 3.6 commissioning
// profile uses the manufacturer's range; it does not inherit a cadence pass.
export const YOGU_PRO_TIMER_PAIRS=[[10,300],[30,30],[60,60],[10,30],[10,60],[30,0],[132,132]];
export const YOGU_D3_TIMED_PROFILE='yogu-d3-timed-20261009';
// Explicitly assigned commissioning profiles. These are NOT supplier-confirmed
// firmware limits: only the user's requested value is allowed for a controlled
// trial using each model's manual syntax. ACK does not verify seconds/effect.
export const YOGU_INTERVAL_TRIALS={
 'yogu-t11-interval-trial-20261008':{model:'T11',command:'GPSUI'},
 'yogu-t12-interval-trial-20261008':{model:'T12',command:'GPSUI'},
 'yogu-d3-pro-interval-trial-20261008':{model:'D3 Pro',command:'TIMER'},
};
export function gpsControlProfile(key) {
  const driveModel=yoguDriveControlModel(key);
  if(driveModel)return {
    id:key,model:driveModel,interval:false,intervalMin:0,intervalMax:0,
    intervalUnit:'seconds',minimumConfirmed:false,position:false,restart:false,
    parameters:true,queries:['version','parameters','status','interval','sleep','acc','sim'],
    vibration:null,deviceOverspeed:null,
    ...(Object.hasOwn(YOGU_DRIVE_CONTROLS,key)?{
      interval:true,timerPair:true,requiredFirmware:'T89S_V5.9',
      allowedIntervals:[5,30],additionalIntervalPresets:[5],intervalPresetAccOff:0,
      sleep:true,acc:true,
    }:{}),
  };
  if(key===YOGU_PRO_36_PROFILE)return {
    ...gpsControlProfile(YOGU_PRO_READBACK_TRIAL),id:key,requiredFirmware:'GT76E_V3.6',
    intervalMin:5,intervalMax:86400,allowedIntervals:null,timerRange:true,
    // D3Pro.xlsx C13: 0 or 5..86400; keep ACC ON > 0 so this interval control
    // cannot disable all position reports. 0 remains explicit for ACC OFF.
    additionalIntervalPresets:[5,10],
  };
  if(key===YOGU_D3_TIMED_PROFILE)return {id:key,model:'D3',interval:false,intervalMin:0,intervalMax:0,allowedIntervals:[],intervalUnit:'minutes',minimumConfirmed:false,sleepHeartbeatSeconds:null,position:false,restart:false,parameters:false,modes:true,modeUnit:'minutes',modeMin:0,modeMax:1440,vibration:null,deviceOverspeed:null};
  if(Object.hasOwn(YOGU_SUPPLIER_CONTROLS,key))return {
    id:key,model:YOGU_SUPPLIER_CONTROLS[key].model,intervalMin:5,intervalMax:120,
    intervalUnit:'seconds',minimumConfirmed:true,sleepHeartbeatSeconds:null,
    position:true,restart:true,parameters:true,queries:['parameters'],
    vibration:null,deviceOverspeed:null,
  };
  if(key===YOGU_PRO_READBACK_TRIAL)return {
    id:key,model:'D3 Pro',intervalMin:10,intervalMax:132,allowedIntervals:[10,30,60,132],
    timerPair:true,requiredFirmware:'GT76E_V3.4',
    intervalUnit:'seconds',minimumConfirmed:false,sleepHeartbeatSeconds:null,
    trialOnly:true,position:false,restart:false,parameters:true,
    queries:['version','parameters','status','interval'],vibration:null,deviceOverspeed:null,
  };
  const trial=Object.hasOwn(YOGU_INTERVAL_TRIALS,key)?YOGU_INTERVAL_TRIALS[key]:null;
  if(trial)return {id:key,model:trial.model,interval:trial.model!=='D3 Pro',intervalMin:30,intervalMax:30,allowedIntervals:[30],intervalUnit:'unverified',minimumConfirmed:false,sleepHeartbeatSeconds:null,trialOnly:true,position:false,restart:false,parameters:false,vibration:null,deviceOverspeed:null};
  return key === YG_T11_CONTROL_PROFILE ? {
    id: key, intervalMin: 5, intervalMax: 120, intervalUnit: 'seconds',
    // Supplier follow-up 2026-09-28: 5 seconds minimum; sleep replies refer to SMS.
    minimumConfirmed: true, sleepHeartbeatSeconds: 300,
    // The legacy WMODE command changes ongoing reporting; it is not a one-off fix.
    position:false,
    parameters: true, vibration: false, deviceOverspeed: false,
  } : null;
}
export function validGpsInterval(value, control) {
  if(control?.timerPair){
    if(!value||typeof value!=='object'||Array.isArray(value)||Object.keys(value).length!==2||!Object.keys(value).every(k=>['accOn','accOff'].includes(k)))return false;
    if(Object.hasOwn(YOGU_DRIVE_CONTROLS,control.id))return YOGU_DRIVE_TIMER_PAIRS.some(([on,off])=>value.accOn===on&&value.accOff===off);
    if(control.id===YOGU_PRO_36_PROFILE){const seconds=n=>Number.isInteger(n)&&n>=5&&n<=86400;return seconds(value.accOn)&&(value.accOff===0||seconds(value.accOff));}
    return YOGU_PRO_TIMER_PAIRS.some(([on,off])=>value.accOn===on&&value.accOff===off);
  }
  return Boolean(control && Number.isInteger(value) && (control.allowedIntervals?control.allowedIntervals.includes(value):value >= control.intervalMin && value <= control.intervalMax));
}
export function gpsControlMatchesModel(key,model){return yoguDriveControlModel(key)?yoguDriveControlModel(key)===model:key===YG_T11_CONTROL_PROFILE?model==='YG-T11':key===YOGU_D3_TIMED_PROFILE?model==='D3':[YOGU_PRO_READBACK_TRIAL,YOGU_PRO_36_PROFILE].includes(key)?model==='D3 Pro':Object.hasOwn(YOGU_SUPPLIER_CONTROLS,key)?YOGU_SUPPLIER_CONTROLS[key].model===model:Object.hasOwn(YOGU_INTERVAL_TRIALS,key)&&YOGU_INTERVAL_TRIALS[key].model===model;}
export function gpsControlAllows(profile,action){
 const control=gpsControlProfile(profile?.gpsControl?.id);
 return Boolean(profile?.protocol==='gt06'&&control&&gpsControlMatchesModel(control.id,profile.model)&&
  (action==='interval'&&control.interval!==false&&(!control.requiredFirmware||profile.firmware===control.requiredFirmware)||['sleep','acc'].includes(action)&&control[action]===true&&profile.firmware===control.requiredFirmware||action==='mode'&&control.modes===true||action==='parameters'&&control.parameters===true||action==='position'&&control.position!==false||action==='restart'&&control.restart!==false));
}
// Derive capabilities from the registered profile id, never client-supplied
// query metadata. Baseline commissioning reads remain available before VERSION.
export function gpsControlQueries(profile){
 if(!gpsControlAllows(profile,'parameters'))return [];
 const control=gpsControlProfile(profile.gpsControl.id),queries=control.queries??[];
 return yoguDriveControlModel(control.id)&&profile.firmware==='T89S_V5.9'
  ? [...queries,...Object.keys(DRIVE_ALARM_QUERIES)] : [...queries];
}
// T94 SMS Commands R21/R23. Zero is an explicit customer selection, never a
// default: GPS stays on continuously; activity mode zero is adaptive ACC.
export function validGpsSetting(value,action){return Number.isInteger(value)&&value>=0&&(action==='sleep'?value<=300:action==='acc'?value<=2:false);}
export function gpsControlCommand(profile,action,value,query='parameters'){
 if(!gpsControlAllows(profile,action))throw Error('feature_unavailable');
 const control=gpsControlProfile(profile.gpsControl.id);
 if(['sleep','acc'].includes(action)){
  if(!validGpsSetting(value,action))throw Error('invalid_setting');
  return action==='sleep'?`SENDS,${value}#`:`YG,ACCSET:${value}#`;
 }
 if(action==='mode'){
  if(!Number.isInteger(value)||value<control.modeMin||value>control.modeMax)throw Error('invalid_mode');
  return `YG,IT:${value}#`;
 }
 if(action==='interval')return gpsIntervalCommand(value,control);
 if(action==='parameters'){
   if(typeof query!=='string')throw Error('invalid_query');
  if(yoguDriveControlModel(control.id)){
   const queries={version:'VERSION#',parameters:'PARAM#',status:'STATUS#',interval:'TIMER#',sleep:'SENDS#',acc:'YG,ACCSET#',sim:'ICCID#',...DRIVE_ALARM_QUERIES};
   if(!Object.hasOwn(queries,query)||!gpsControlQueries(profile).includes(query))throw Error('invalid_query');
   return queries[query];
  }
  if([YOGU_PRO_READBACK_TRIAL,YOGU_PRO_36_PROFILE].includes(control.id)){
   const queries={version:'VERSION#',parameters:'PARAM#',status:'STATUS#',interval:'TIMER#'};
   if(!Object.hasOwn(queries,query))throw Error('invalid_query');
   return queries[query];
  }
  if(query!=='parameters')throw Error('invalid_query');
  return 'YGCX#';
 }
 if(action==='restart')return 'YGRESET#';
 // Sheet1!B33 is exactly DWXX, without adding a guessed prefix or suffix.
 if(Object.hasOwn(YOGU_SUPPLIER_CONTROLS,control.id))return 'DWXX';
 throw Error('feature_unavailable');
}
export function gpsIntervalCommand(value,control){
 const trusted=gpsControlProfile(control?.id);
 if(!validGpsInterval(value,trusted))throw Error('invalid_interval');
 if(trusted.interval===false)throw Error('feature_unavailable');
 if(trusted.timerPair)return `TIMER${Object.hasOwn(YOGU_DRIVE_CONTROLS,trusted.id)?',':':'}${value.accOn},${value.accOff}#`;
 return `${trusted.id===YOGU_PRO_READBACK_TRIAL?'TIMER':YOGU_INTERVAL_TRIALS[trusted.id]?.command??'GPSUI'}:${value}#`;
}
